var map = {
	"./aoc_meme.png": 586,
	"./fosdem_logo.png": 850,
	"./icpc_logo.png": 45,
	"./image_not_found.png": 874,
	"./node_modules.jpg": 18,
	"./projectlist": 178,
	"./projectlist.json": 178,
	"./raspberry_pi.jpg": 484,
	"./saf_2023.svg": 500,
	"./the_c_programming_language.png": 550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;